// extracted by mini-css-extract-plugin
module.exports = {"budgetSettings":"src-components-BudgetBuilder-SponsorCosts-Main-styles___budgetSettings"};